var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"etapa-selo",class:_vm.selo.classe},[_vm._v(_vm._s(_vm.selo.texto))])
}
var staticRenderFns = []

export { render, staticRenderFns }